export default "__VITE_ASSET__C4J87g_6__"